import React from 'react';
import './RefundPolicyPage.css';

const RefundPolicyPage = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Refund Policy — TRYON</h1>
          <p className="last-updated">Last Updated: 29/12/2025</p>
        </div>

        <div className="policy-intro">
          <p>
            Thank you for shopping with TRYON! We take pride in creating products made specially for you.
            Since each T-shirt is custom printed, refunds are handled under the following conditions:
          </p>
        </div>

        <div className="policy-section">
          <h2>1. Eligibility for Refunds</h2>
          <p>Refunds are only applicable if:</p>
          <ul>
            <li>The product arrives damaged or defective.</li>
            <li>You receive an incorrect product (wrong size, design, or color dispatched).</li>
          </ul>
          
          <div className="highlight-box">
            <h3>To claim a refund:</h3>
            <ul>
              <li>Contact us within 48 hours of delivery.</li>
              <li>Provide clear unboxing photos/video as proof.</li>
              <li>The item must be unused, unwashed, and in original packaging.</li>
            </ul>
            <p>If approved, we will process a refund or provide a replacement based on your preference.</p>
          </div>
        </div>

        <div className="policy-section">
          <h2>2. Non-Refundable Situations</h2>
          <p>Refunds are not eligible if:</p>
          <ul className="warning-list">
            <li>Incorrect size ordered by customer.</li>
            <li>Change of mind or no longer needed.</li>
            <li>Visible signs of use, washing, or damage caused by customers.</li>
            <li>Claims made after 48 hours of delivery.</li>
            <li>Custom name/print issues due to user-provided incorrect spelling/design.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Refund Method</h2>
          <div className="refund-methods">
            <div className="method-card">
              <h3>Prepaid Orders</h3>
              <p>Refund issued back to original payment method.</p>
            </div>
            <div className="method-card">
              <h3>COD Orders</h3>
              <p>Refund issued as store credit or coupon.</p>
            </div>
          </div>
          <p className="note">Refund may take 7–10 business days after quality check approval.</p>
        </div>

        <div className="policy-section">
          <h2>4. Return Pickup & Charges</h2>
          <div className="charges-grid">
            <div className="charge-card success">
              <div className="icon">✔</div>
              <h3>If TRYON is at fault</h3>
              <p>(wrong/damaged item)</p>
              <p className="highlight">Return pickup is FREE</p>
            </div>
            <div className="charge-card error">
              <div className="icon">✘</div>
              <h3>Other reasons</h3>
              <p>(customer request)</p>
              <p className="highlight">Returns not accepted</p>
            </div>
          </div>
        </div>

        <div className="policy-section">
          <h2>5. Order Cancellation</h2>
          <ul>
            <li>Orders can be cancelled within 24 hours of purchase.</li>
            <li>Once production begins, cancellation is not allowed.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Exchanges vs Refunds</h2>
          <p>
            Where possible, we may offer replacement/exchange instead of refund to solve issues faster.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Contact Support</h2>
          <p>To raise a refund request, reach us at:</p>
          <div className="contact-info">
            <p>📧 Email: <a href="mailto:tyon.wear02@gmail.com">tyon.wear02@gmail.com</a></p>
            <p>📞 Contact: <a href="tel:+919265490049">+91 9265490049</a></p>
          </div>
        </div>

        <div className="policy-footer">
          <p>By placing an order with TRYON, you agree to all terms stated in this Refund Policy</p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
